import { Tempo as M_Tempo } from '#~/control/movement/index.js';
import { Sel, STagNew } from '#~/stag/index.js';
import type { TempoProps } from './types.js';
import * as ToggleGroup from '@studio/design-system/toggle/group';
import type { ReactElement } from 'react';

/** `<Tempo>` component. */
export const Tempo = ({ tempo, ...props }: TempoProps): ReactElement => (
  <ToggleGroup.Container label='Speed' {...props}>
    <ToggleGroup.Root
      onValueChange={tempo.setValue}
      className='mt-2'
      type='single'
      value={tempo.value}
    >
      {/*
       * Per rule: playwright-stag-selectors-only (ai.knowledge/platform) —
       * STag attributes let HIL e2e tests click these items by stag id
       * rather than text, which is fragile under i18n.
       */}
      <ToggleGroup.Item
        value={M_Tempo.Fixed}
        {...STagNew(Sel.MainRoomRightTrayControls, 'tempo', 'fixed')}
      >
        Fixed
      </ToggleGroup.Item>
      <ToggleGroup.Item
        value={M_Tempo.Variable}
        {...STagNew(Sel.MainRoomRightTrayControls, 'tempo', 'variable')}
      >
        Variable
      </ToggleGroup.Item>
    </ToggleGroup.Root>
  </ToggleGroup.Container>
);
